import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})


export class Config {
//  kundenId:string =  '99991';
 kundenId:string =  '5';
 dataBaseUrl:string = "https://r2.maereo.de/backend/api";
}
